import TrackWrapper from '~/components/common/TrackWrapper';
import DisclaimerText from '../common/DisclaimerText/DisclaimerText';

export default function Disclaimer() {
  return (
    <TrackWrapper event={{ eventName: 'Viewed - Ev Guide Disclaimer' }}>
      <DisclaimerText>
        Disclaimer: This content is not meant to provide legal advice. We do our
        best to provide accurate information, but please conduct your own
        research before transacting and consider talking to a qualified
        professional about your unique circumstances. All third-party websites
        referenced/linked on this page are the property of their respective
        owners and do not constitute or imply endorsement, sponsorship, or
        recommendation of Carvana.
      </DisclaimerText>
    </TrackWrapper>
  );
}
